import React from 'react';
import ReactDOM from 'react-dom';
import NotFound from '@components/pages/NotFound';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import VoucherLandingPage from '@components/pages/VoucherLandingPage';

import '~/app.scss';

const App = () => {
    return (
        <div>
            <Router>
                <Switch>
                    <Route path="/:slug" exact component={VoucherLandingPage} />
                    {/* <Route path="/:section/:code" component={Attendance} /> */}
                    <Route component={NotFound} />
                </Switch>
            </Router>
        </div>
    )
}

ReactDOM.render(
    <App/>,
document.getElementById('root')
);

module.hot && module.hot.accept();
